module.exports = __webpack_public_path__ + "img/profile.de8d6d5c.jpg";